import template from './tabs.pug';

const MODULE_NAME = 'tabs';
class TabsController {
	constructor($timeout) {
		'ngInject';
		this.$timeout = $timeout;
		this.tabModel = {
			scrollByPixels: 100,
			disableLeftArrow: true,
			disableRightArrow: true,
			showOsszesito: false,
			arrowButtonWidthInPixel: 40
		};
		this.tabs = [];
	}

	$onInit() {
		this.tabsContainer = document.getElementsByClassName('summary-nav')[0];
	}

	$onChanges(changeObject) {
		if (changeObject.eredmenyTabok && changeObject.eredmenyTabok.currentValue) {
			this.tabs = angular.copy(this.eredmenyTabok);
			if (this.tabs.length >= 2) {
				this.tabModel.showOsszesito = true;
			} else {
				this.tabModel.showOsszesito = false; // when reset all calculation results
			}
			// activeTabIndex és az eredmenyTabok együtt változnak kivéve,
			// ha az activeTabIndex az összesítőn áll és Másra is kalkulálok,
			// akkor egy új tab jön létre,
			// amely esetben activeTabIndex értéke nem változik és így nem fut le a
			// setActiveOrDisableToArrow függvény így disable marad a right arrow
			if (!changeObject.activeTabIndex && this.tabs.length >= 2) {
				this.setActiveOrDisableToArrow();
				this.scrollToTabNode();
			}
		}
		if (changeObject.activeTabIndex && !changeObject.activeTabIndex.isFirstChange()) {
			this.activeTabIndex = angular.copy(this.activeTabIndex);
			this.setActiveOrDisableToArrow();
			this.scrollToTabNode();
		}
	}

	setActiveOrDisableToArrow() {
		if (this.activeTabIndex == 0) {
			this.tabModel.disableLeftArrow = true;
		} else {
			this.tabModel.disableLeftArrow = false;
		}
		let tabsArrayLength = this.tabModel.showOsszesito ? 0 : 1;
		if (this.activeTabIndex == this.eredmenyTabok.length - tabsArrayLength) {
			this.tabModel.disableRightArrow = true;
		} else {
			this.tabModel.disableRightArrow = false;
		}
	}

	scrollButtonDown(event, direction) {
		event.stopPropagation();

		if (direction == 'left' && !this.tabModel.disableLeftArrow) {
			this.changeModelWhenSelectNewTab(this.activeTabIndex - 1);
		} else if (direction == 'right' && !this.tabModel.disableRightArrow) {
			this.changeModelWhenSelectNewTab(this.activeTabIndex + 1);
		}
	}

	scrollTo(element, change, duration, isLinear) {
		let start = element.scrollLeft;
		let increment = 20;
		let position = 0;
		let self = this;

		let animateScroll = function (elapsedTime) {
			elapsedTime += increment;
			if (isLinear) {
				position = self.linearTween(elapsedTime, start, change, duration);
			} else {
				position = self.easeInOutQuad(elapsedTime, start, change, duration);
			}
			element.scrollLeft = position;
			if (elapsedTime < duration) {
				setTimeout(function () {
					animateScroll(elapsedTime);
				}, increment);
			}
		};
		animateScroll(0);
	}

	linearTween(currentTime, start, change, duration) {
		return change * currentTime / duration + start;
	}

	easeInOutQuad(currentTime, start, change, duration) {
		currentTime /= duration / 2;
		if (currentTime < 1) {
			return change / 2 * currentTime * currentTime + start;
		}
		currentTime--;
		return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
	}

	changeModelWhenSelectNewTab(tabId) {
		this.onSelectTab({tabId: tabId});
	}

	// Scroll to a tab if it is not entirely visible
	scrollToTabNode() {
		let scrollDuration = 150;
		let tabNode = this.tabsContainer.getElementsByClassName('active')[0];

		if (!tabNode) {
			return;
		}

		let tabWidth = tabNode.offsetWidth,
			tabOffsetLeft = tabNode.offsetLeft - tabWidth,
			tabOffsetRight = tabOffsetLeft + tabWidth,
			containerWidth = this.tabsContainer.offsetWidth,
			containerScrollLeft =  this.tabsContainer.scrollLeft + this.tabModel.arrowButtonWidthInPixel;

		if (containerScrollLeft > tabOffsetLeft) {
			// scroll to the left, if the tab is overflowing on the left side
			let realScroll = 0 - this.tabModel.scrollByPixels;
			this.scrollTo( this.tabsContainer, realScroll, scrollDuration, true);
		} else if (tabOffsetRight > containerWidth) {
			// scroll to the right, if the tab is overflowing on the right side
			let realScroll = this.tabModel.scrollByPixels;
			this.scrollTo( this.tabsContainer, realScroll, scrollDuration, true);
		}
	}
}

export default angular.module(MODULE_NAME, [])
	.component(MODULE_NAME, {
		controller: TabsController,
		template: template(),
		bindings: {
			eredmenyTabok: '<',
			activeTabIndex: '<',
			onSelectTab: '&'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/gazdalkodasikalkulator/tabs/tabs.js